import { __assign, __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { exitOrEmptyString } from '../../base/utils';
import { IDocMetaDomainService } from '../../doc-meta/service/doc-meta-domain-service.interface';
import { ADD_WX_SHARE_COUNT, GET_WX_SHARE_COUNT, STOP_WX_SHARE, WX_SHARE, } from './cgi-path';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
var WX_SHARE_RIGHT_FLAG_DEFAULT = 2;
var WX_SHARE_TYPE_DEFAULT = 1;
var WX_SHARE_PAGE_DEFAULT = 'h5';
var WX_SHARE_AC_DEFAULT = 'share';
var WeChatShareRepository = /** @class */ (function () {
    function WeChatShareRepository(docMetaDomainService, networkRequestService) {
        this.docMetaDomainService = docMetaDomainService;
        this.networkRequestService = networkRequestService;
    }
    WeChatShareRepository.prototype.addWxShareLinkCount = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = {
                    doc_id: this.docMetaDomainService.docMetaEntity.padInfo.padId,
                    token: token,
                };
                return [2 /*return*/, this.networkRequestService.instance.post(ADD_WX_SHARE_COUNT, __assign({}, params))];
            });
        });
    };
    WeChatShareRepository.prototype.fetchWxShareLinkCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = {
                    doc_id: this.docMetaDomainService.docMetaEntity.padInfo.padId,
                };
                return [2 /*return*/, this.networkRequestService.instance.post(GET_WX_SHARE_COUNT, __assign({}, params))];
            });
        });
    };
    WeChatShareRepository.prototype.wxShare = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var groupId, shareLink, policy, params;
            return __generator(this, function (_a) {
                groupId = options.groupId, shareLink = options.shareLink, policy = options.policy;
                params = {
                    groupId: exitOrEmptyString(groupId),
                    domainId: this.docMetaDomainService.docMetaEntity.padInfo.domainId,
                    padId: this.docMetaDomainService.docMetaEntity.padInfo.padId,
                    page: WX_SHARE_PAGE_DEFAULT,
                    right_flag: WX_SHARE_RIGHT_FLAG_DEFAULT,
                    type: WX_SHARE_TYPE_DEFAULT,
                    param: encodeURIComponent(shareLink),
                    ac: WX_SHARE_AC_DEFAULT,
                    policy: policy,
                    xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                };
                return [2 /*return*/, this.networkRequestService.instance.post(WX_SHARE, __assign({}, params))];
            });
        });
    };
    WeChatShareRepository.prototype.stopWxShare = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = {
                    doc_id: this.docMetaDomainService.docMetaEntity.padInfo.padId,
                };
                return [2 /*return*/, this.networkRequestService.instance.post(STOP_WX_SHARE, __assign({}, params))];
            });
        });
    };
    WeChatShareRepository = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, INetworkRequestService),
        __metadata("design:paramtypes", [Object, Object])
    ], WeChatShareRepository);
    return WeChatShareRepository;
}());
export default WeChatShareRepository;
